module.exports = __webpack_public_path__ + "aq.svg?54cf99ae46044f5f2fa8ed1b404c3f66";